import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import get from 'lodash/get';

import { excludedProducts } from 'Redux/ducks/user-review';

const RatingAndRecommended = ({
  item,
  productId,
}) => {
  const [rating, setRating] = useState(0);

  const { rating: _rating, reviewId } = item;


  useEffect(() => {
    setRating(_rating);
  }, [_rating]);

  const starRatingButtons = () => {
    const starButtons = [...Array(rating).keys()].map(score =>
      <button
        className="star-rating-button highlighted-star"
        key={score}
        aria-label="Star rating"
        onClick={() => {}}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90" preserveAspectRatio="xMinYMid meet" role="img" aria-label="User review star">
          <polygon points="45 0 58.91 29.63 90 34.38 67.5 57.44 72.81 90 45 74.63 17.19 90 22.5 57.44 0 34.38 31.09 29.63 45 0" />
        </svg>
      </button>,
    );

    return starButtons;
  };

  const redeem = get(item, 'drm.redeem');
  const voucher = get(item, 'drm.voucher');
  const isExcluded = excludedProducts.includes(item._id);

  if (item.mystery || item.bid || item.type === 'bundle' || redeem || voucher || isExcluded) return false;

  return (
    <Link to={`/review/${productId}`} className="key-library-review-container">
      {reviewId &&
        <div className="star-rating-buttons-container mr-2">
          {starRatingButtons(rating)}
        </div>
      }
      <div>
        {reviewId && <FormattedMessage id="keylibrarycardreview.editreview" defaultMessage="Edit Review" />}
        {!reviewId && <FormattedMessage id="keylibrarycardreview.addreview" defaultMessage="Add Review" />}
      </div>
    </Link>
  );
};


RatingAndRecommended.propTypes = {
  item: PropTypes.shape({}),
  productId: PropTypes.string,
};

RatingAndRecommended.defaultProps = {
  item: {
    rating: 0,
    recommend: undefined,
    productId: '',
  },
  productId: '',
};

export default RatingAndRecommended;
